import { BrowserRouter, Routes, Route } from 'react-router-dom';

import ScrollToTop from './utils/scrollToTop';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Main from './components/Main/Main';
// import Community from './components/Community/Community';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import ProjectDetail from './components/common/ProjectDetail';
import Login from './components/Login/Login';
import Admin from './components/Admin/Admin';
import RequireAuth from './components/RequireAuth';

import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header title="Morena Sanchez" subtitle="Fotógrafa" />
        <Routes>
          <Route exact path="/" element={<Main />} />
          <Route exact path="/inicio" element={<Main />} />

          <Route path="/proyecto/:id" element={<ProjectDetail />} />

          <Route exact path="/about" element={<About />} />
          <Route exact path="/contacto" element={<Contact />} />
          <Route exact path="/login" element={<Login />} />
          <Route
            exact
            path="/admin"
            element={
              <RequireAuth>
                <Admin />
              </RequireAuth>
            }
          />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
